import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UISection from 'UIComponents/section/UISection';
import { jsx as _jsx } from "react/jsx-runtime";
export function NoEditPermissionsAlert() {
  return /*#__PURE__*/_jsx(UISection, {
    children: /*#__PURE__*/_jsx(UIAlert, {
      type: "tip",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "subscriptions.permissions.noEditRecordPermissionsWarning"
      })
    })
  });
}